//clientActions and clientReducers will be replaced by userActions and userReducers and removed as soon as the backend is implemented
import {
  CLIENTS_LIST_REQUEST,
  CLIENTS_LIST_SUCCESS,
  CLIENTS_LIST_FAILURE,
  CLIENTS_LIST_RESET,
  CLIENT_DETAILS_REQUEST,
  CLIENT_DETAILS_SUCCESS,
  CLIENT_DETAILS_FAILURE,
  CLIENT_CREATE_REQUEST,
  CLIENT_CREATE_SUCCESS,
  CLIENT_CREATE_FAILURE,
  CLIENT_CREATE_RESET,
  CLIENT_UPDATE_REQUEST,
  CLIENT_UPDATE_SUCCESS,
  CLIENT_UPDATE_FAILURE,
  CLIENT_UPDATE_RESET,
  CLIENT_DELETE_REQUEST,
  CLIENT_DELETE_SUCCESS,
  CLIENT_DELETE_FAILURE,
  CLIENT_DELETE_RESET,
} from "../constants/clientConstants";

export const clientsListReducer = (state = { clients: [] }, action) => {
  switch (action.type) {
    case CLIENTS_LIST_REQUEST:
      return { loading: true };
    case CLIENTS_LIST_SUCCESS:
      return { loading: false, clients: action.payload };
    case CLIENTS_LIST_FAILURE:
      return { loading: false, error: action.payload };
    case CLIENTS_LIST_RESET:
      return { clients: [] };
    default:
      return state;
  }
};

export const clientDetailsReducer = (state = { client: {} }, action) => {
  switch (action.type) {
    case CLIENT_DETAILS_REQUEST:
      return { ...state, loading: true };
    case CLIENT_DETAILS_SUCCESS:
      return { loading: false, client: action.payload };
    case CLIENT_DETAILS_FAILURE:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const clientCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case CLIENT_CREATE_REQUEST:
      return { loading: true };
    case CLIENT_CREATE_SUCCESS:
      return { loading: false, success: true, client: action.payload };
    case CLIENT_CREATE_FAILURE:
      return { loading: false, error: action.payload };
    case CLIENT_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

export const clientUpdateReducer = (state = { client: {} }, action) => {
  switch (action.type) {
    case CLIENT_UPDATE_REQUEST:
      return { loading: true };
    case CLIENT_UPDATE_SUCCESS:
      return { loading: false, success: true, client: action.payload };
    case CLIENT_UPDATE_FAILURE:
      return { loading: false, error: action.payload };
    case CLIENT_UPDATE_RESET:
      return {
        client: {},
      };
    default:
      return state;
  }
};

export const clientDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case CLIENT_DELETE_REQUEST:
      return { loading: true };
    case CLIENT_DELETE_SUCCESS:
      return { loading: false, success: true };
    case CLIENT_DELETE_FAILURE:
      return { loading: false, error: action.payload };
    case CLIENT_DELETE_RESET:
      return {};
    default:
      return state;
  }
};
